module.exports = __webpack_public_path__ + "img/alarmMap.30b4e536.svg";